import { useQuery } from '@tanstack/react-query';
import { useAddOnLogError } from './helpers/useAddOnError';
export const createUseBosQuery = ({ onLogError }) => (options) => {
    const query = useQuery(options);
    return useAddOnLogError(query, onLogError);
};
